import { render, staticRenderFns } from "./OffersFilters.vue?vue&type=template&id=22327cff"
import script from "./OffersFilters.vue?vue&type=script&lang=js"
export * from "./OffersFilters.vue?vue&type=script&lang=js"
import style0 from "./OffersFilters.vue?vue&type=style&index=0&id=22327cff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports